module Login {
    export class LoginData {
        public userName: string;
        public password: string;
        public sessionId: string;
        public apiKeySource: string;
    }
}